import { CoverageMap } from 'src/features/homeowners/components/coverage-map/coverage-map';
import { CoverageCity } from 'src/features/homeowners/homeowners.types';

type Props = {
  coverageCities: CoverageCity[];
};

export const CoverageMapSlice = ({ coverageCities }: Props) => (
  <div className="container flex justify-center">
    <CoverageMap coverageCities={coverageCities} />
  </div>
);
